import { DEFAULT_BRAND } from "@shared/brand.types";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { BrandRoot } from "./components/BrandRoot";
import { EcolePage } from "./ecole/EcolePage";
import { EspacePage } from "./espace/EspacePage";
import { AccessPage } from "./pages/AccessPage";
import { DepositPage } from "./pages/DepositPage";
import { EmbedPage } from "./pages/EmbedPage";
import { MyRequestsPage } from "./pages/MyRequestsPage";
import { SharePage } from "./pages/SharePage";

/**
 * Deux portes d'entrée, et elles n'ont pas la même nature.
 *
 * `/e/:slug` et `/embed/:slug` sont PUBLIQUES : une entreprise arrive du site de son
 * école, personne ne la connaît encore. Elles portent la marque de l'école, qu'elles
 * chargent elles-mêmes.
 *
 * `/acces/:token`, `/partage` et `/mes-demandes` demandent un code. Elles portent la
 * marque Mentor Goal, parce qu'au moment où elles s'affichent on ne sait pas encore
 * de quelle école il s'agit.
 *
 * `/ecole/*` est la porte de l'ÉCOLE, et elle porte sa coque elle-même : elle affiche
 * la porte à code ou ses trois onglets selon la session (sous-routes dans
 * `EcolePage`, comme pour `/espace/*`), et prend la couleur de
 * l'école dès qu'elle la connaît.
 *
 * `/espace/*` vient APRÈS le code : c'est la seule famille qui a sa propre coque et
 * ses propres sous-routes, et elle reprend la marque de l'école dès qu'elle sait
 * laquelle. Son `/*` est délibéré — les sous-routes vivent dans `EspacePage`, avec
 * la coque qui les entoure, plutôt qu'à plat ici où chacune la redéclarerait.
 *
 * Les autres sont déclarées à PLAT dans une seule table de routes : un `<Routes>`
 * imbriqué sous un `path="*"` fait résoudre les chemins enfants relativement au
 * parent, et les chemins absolus n'y matchent plus.
 */
const brandedByMentorGoal = (page: React.ReactNode) => (
	<BrandRoot brand={DEFAULT_BRAND} className="min-h-screen bg-mg-subtle">
		{page}
	</BrandRoot>
);

export function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/e/:slug" element={<DepositPage />} />
				<Route path="/embed/:slug" element={<EmbedPage />} />
				<Route path="/espace/*" element={<EspacePage />} />
				<Route path="/ecole/*" element={<EcolePage />} />
				<Route path="/mes-demandes" element={brandedByMentorGoal(<MyRequestsPage />)} />
				<Route path="/acces/:token" element={brandedByMentorGoal(<AccessPage />)} />
				<Route path="/partage" element={brandedByMentorGoal(<SharePage />)} />
				<Route path="*" element={<Navigate to="/mes-demandes" replace />} />
			</Routes>
		</BrowserRouter>
	);
}
